import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';
import { HttpResponse } from '@angular/common/http';
import { LocalOffice } from '../../store/admin/local-office/local-office.interface';

@Injectable({ providedIn: 'root' })
export class LocalOfficesRestService {
  constructor(protected restService: RestService) {}

  getAll(): Observable<LocalOffice[]> {
    return this.restService.get<LocalOffice[]>('/LocalOffice');
  }

  save(localOffice: LocalOffice): Observable<unknown> {
    return this.restService.post<unknown>('/LocalOffice', localOffice);
  }
}
